import i18n from "../i18n";

export const getFormattedPreferredLanguage = () =>  i18n.language.toLowerCase();
export default getFormattedPreferredLanguage